import React from 'react';
import { IGenerateLink } from '../../../interfaces';
import { google, ics } from "calendar-link";
import moment from 'moment';
import { useSelector } from 'react-redux';
import { AiFillApple } from 'react-icons/ai';
import { AiOutlineGoogle } from 'react-icons/ai';
import { SiMicrosoftoutlook } from 'react-icons/si';

function Popup(props: any) {

  const allInfo = useSelector((state: any) => state);

  const handleClick = (calendarName: string) => {
    if(props.session && allInfo.common.selectedLanguage && allInfo.peopleInformation.data) {
      let instructionUrl = (allInfo.common.selectedLanguage === "EN") ? `${process.env.REACT_APP_GE_SUPPORT_URL}/EN-EN/solutions/one/twt` : `${process.env.REACT_APP_GE_SUPPORT_URL}/${allInfo.common.selectedLanguage}/solutions/one/twt`;      
      let faqUrl = `${process.env.REACT_APP_ASSETS_URL}/halo/twt/twt_${allInfo.common.selectedLanguage.toLowerCase()}.pdf`;

      let instructionLink = (calendarName === "google") ? `<a href='${instructionUrl}'>${instructionUrl}</a>` : instructionUrl;
      let faqLink = (calendarName === "google") ? `<a href='${faqUrl}'>${faqUrl}</a>` : faqUrl;
      let twtLink = (calendarName === "google") ? `<a href='${process.env.REACT_APP_TWT_URL}'>${process.env.REACT_APP_TWT_URL}</a>` : process.env.REACT_APP_TWT_URL;
      
      let calendarDescription = `Hello ${allInfo.peopleInformation.data.getpeopleInformation.username},
      \nHere are the details about your upcoming Talk With Teacher session:
      \nTopic : ${props.session['topic'] ? props.session['topic']['name'] : 'Topic name not available'}.
      \nDate : ${props.session['topic'] ? moment(props.session['startTime']).format("DD MMMM YYYY") : "Not available"}
      \nStart Time : ${moment(props.session['startTime']).format('hh:mm A')}
      \nPlease click : ${twtLink}
      \nWe strongly recommend that you read our Class Policy, ${instructionLink}, ${faqLink}, 
      \nEnjoy your Talk with the Teacher session
      \nThe Learnship Team`;

      const event : IGenerateLink = {
        title: "Talk with the Teacher Upcoming Session",
        description: calendarDescription,
        start: props.session['startTime'],
        duration: [1, "hour"],
        location : `${process.env.REACT_APP_TWT_URL}`
      };
  
      if(calendarName === "outlook") {
        window.open(ics(event));
      } else if(calendarName === "apple") {
        window.open(ics(event));
      } else if(calendarName === "google") {
        window.open(google(event));
      }
    }
  }

  const getTopicTitle = (session: any) => {
    if(session.classType.levelIds) {
      if(session.classType.levelIds.length > 0) {
        let levels = session?.classType.levelIds.slice().sort((a: any, b: any) =>  (a.value-b.value));
        return (session?.classType.name + " (" + levels[0].cefr + " - " + levels[levels.length - 1].cefr + ")")
      }
    } else {
      return (session?.classType.name + " (Level not available)")
    }
  }

  return (
    <div className="class-info">
      <div className="date-marker">
        <div className="triangle"></div>
      </div>
      <div className="flex-col-div">
        <div className="grey-bk">
          <p className="level-title">
            <span className="level-clr"></span>
            {getTopicTitle(props.session)}
          </p>
        </div>
        <p className="ng-binding">{moment(props.session?.startTime).format("DD ddd YYYY, MMMM")}</p>
        <div className="cls-duration">
        {props.session?.topic ? 
          <>
            <div>
              <span className="twt-time">{moment(props.session?.startTime).format("HH:mm")}</span> 
              - 
              <span className="twt-time">{moment(props.session?.endTime).format("HH:mm")}</span>
            </div>
          </> : <div className="twt-time">Not available</div> }
        </div>
        <div className="cls-topic">
          <span className="topic-name">
            {props.session?.topic.name}
          </span>
        </div>
        <div className="addToCal">   
          <SiMicrosoftoutlook className="calendarLink" onClick={() => handleClick("outlook")}>Outlook</SiMicrosoftoutlook>
          <AiFillApple className="calendarLink" onClick={() => handleClick("apple")}></AiFillApple>
          <AiOutlineGoogle className="calendarLink" onClick={() => handleClick("google")}></AiOutlineGoogle>
        </div>
      </div>
    </div>
  );
}

export default Popup